import { useEffect } from 'react';
import { COMPANY } from '../../Const';

const ORIGIN = 'https://www.iidakenchikuiruma.com';

/**
 * LocalBusiness（工務店）の構造化データ。
 * 検索結果での住所・電話・営業エリアの表示に効く。全ページ共通で1つだけ置く。
 */
const DATA = {
  '@context': 'https://schema.org',
  '@type': 'GeneralContractor',
  name: '飯田建築有限会社',
  alternateName: '飯田建築',
  url: ORIGIN,
  telephone: COMPANY.tel,
  faxNumber: COMPANY.fax,
  image: `${ORIGIN}/images/background_light.jpg`,
  logo: `${ORIGIN}/images/logo_green_no_title.png`,
  description:
    '埼玉県入間市の工務店。昭和42年の創業以来、新築・リフォーム・店舗改修まで、建築士が一貫して手がける家づくりをご提案しています。',
  foundingDate: '1967',
  address: {
    '@type': 'PostalAddress',
    postalCode: '358-0054',
    addressCountry: 'JP',
    addressRegion: '埼玉県',
    addressLocality: '入間市',
    streetAddress: '野田1481-2',
  },
  areaServed: [
    { '@type': 'City', name: '入間市' },
    { '@type': 'City', name: '飯能市' },
    { '@type': 'City', name: '日高市' },
    { '@type': 'City', name: '狭山市' },
    { '@type': 'City', name: '所沢市' },
    { '@type': 'City', name: '川越市' },
    { '@type': 'City', name: '青梅市' },
    { '@type': 'City', name: '羽村市' },
    { '@type': 'City', name: '瑞穂町' },
    { '@type': 'City', name: '武蔵村山市' },
  ],
  knowsAbout: ['新築', 'リフォーム', 'リノベーション', 'エクステリア', '店舗・オフィス改修'],
  sameAs: [
    'https://www.instagram.com/iida_kenchiku/',
    'https://www.threads.net/@iida_kenchiku',
    'https://twitter.com/iida_kenchiku',
    'https://www.pinterest.jp/kiidac70/',
  ],
};

export default function StructuredData() {
  useEffect(() => {
    const id = 'ld-json-localbusiness';
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(DATA);
  }, []);

  return null;
}
